var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessMsgIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.148,
    height: 18.008,
    viewBox: "0 0 24.148 18.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M8.2,22.231.354,14.383a1.207,1.207,0,0,1,0-1.708l1.708-1.708a1.207,1.207,0,0,1,1.708,0l5.287,5.287L20.38,4.931a1.207,1.207,0,0,1,1.708,0l1.708,1.708a1.207,1.207,0,0,1,0,1.708L9.909,22.231A1.207,1.207,0,0,1,8.2,22.231Z",
    transform: "translate(0 -4.577)",
    fill: "#72a062"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessMsgIcon);
export default __webpack_public_path__ + "static/media/success_msg_icon.ed13129b9b92a2eedd71229dfb1c1525.svg";
export { ForwardRef as ReactComponent };